export default {
  cognito: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_G1ictmEjG",
    CLIENT_ID: "57lva0se7rrt3n5garq7q80osm",
  },
  baseUrl: "https://api.uat.confidentportal.com",
};
